import { Component, OnInit, Inject, ɵConsole } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { ClipboardService } from 'ngx-clipboard';
import { AdminService } from 'src/app/services/admin/admin.service';
import { CampaignService } from 'src/app/services/campaign/campaign.service';
import { DriveService } from 'src/app/services/drive/drive.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { environment } from 'src/environments/environment';
import { log } from 'util';
import { APP_DATE_FORMATS, DateAdapterService } from 'src/app/services/date-adapter.service';
import * as moment from 'moment'
@Component({
  selector: 'app-add-hiring-drive',
  templateUrl: './add-hiring-drive.component.html',
  styleUrls: ['./add-hiring-drive.component.scss'],
  providers: [
    {
    provide: DateAdapter, useClass: DateAdapterService
    },
    {
    provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS
    }
    ]
})
export class AddHiringDriveComponent implements OnInit {

  visible: Boolean = false;
  requestBody = {};
  end: Boolean = true;
  event: Boolean = true;

  dateValue: number;
  monthValue: number;
  yearValue: number;

  todayDate: Date = new Date();
  todayDateYear: number = this.todayDate.getFullYear();
  todayDateMonth: number = this.todayDate.getMonth();
  todayDateDay: number = this.todayDate.getDay();

  listData: any[];
  collegeList = [];
  typeList = [];
  instituteList = [];
  isOthers = false;
  disableButton = false;
  shortNameStatus: boolean = false;
  companyShortNameList = [];


  public minTime: Date;
  public maxTime: Date;
  time1: Boolean = true;
  startAt: Date;
  temp: any;
  branchList: any;
  driveBranch: any;
  shortNameList: any;
  constructor(
    public dialogRef: MatDialogRef<AddHiringDriveComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private clipboardService: ClipboardService,
    private adminService: AdminService,
    private campaign: CampaignService,
    private drive: DriveService,
    private utilityService: UtilityService,
  ) {
  }

  companies: any[] = [];
  institutionArr = [{ value: 'College', id: 'COLLEGE' },
  { value: 'Institute', id: 'TRAINING_INSTITUTE' }, { value: 'BridgeLabz', id: 'BRIDGELABZ' }, { value: 'Others', id: 'OTHERS' }];
  instituteArr = [];
  bridgelabzArr = ['BridgeLabz1', 'BridgeLabz2', 'BridgeLabz3'];
  branchArr = [];
  dataList = [];
  companyShortNameArr = [];

  driveName = new FormControl('', [Validators.required, this.noWhitespaceValidator, Validators.pattern('^[a-zA-Z \-\']+'), Validators.minLength(3)]);
  city = new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z ]*$'), this.noWhitespaceValidator, Validators.minLength(3)]);
  companyShortName = new FormControl('', [Validators.required]);
  institute = new FormControl('', [Validators.required]);
  collegeName = new FormControl('', [Validators.required]);
  branch = new FormControl('', [Validators.required]);
 // address : new FormControl({ value: '', disabled: true}, [Validators.required]);
 // address = new FormControl('', [Validators.required, this.noWhitespaceValidator , Validators.pattern(/^[a-zA-Z0-9\s,'-]*$/)]);
  // address = new FormControl({ value: '', disabled: true }, [Validators.required]);
  address = new FormControl('', [Validators.required]);
  startDate = new FormControl('', [Validators.required]);
  endDate = new FormControl('', [Validators.required]);
  eventDate = new FormControl('', [Validators.required]);
  time = new FormControl('', [Validators.required]);
  //startDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
  // endDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
  // eventDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
  // time = new FormControl({ value: '', disabled: true }, [Validators.required]);
  accessCode = new FormControl('', [Validators.required, Validators.pattern('^[0-9]*[1-9][0-9]*$'), this.noWhitespaceValidator]);
  branchId
  attendanceLink = new FormControl('', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?'), Validators.pattern(/^\S*$/)]);
  minDate = new Date();
  minDate1 = new Date();

  shortName = new FormControl('', [Validators.required, this.noWhitespaceValidator]);
  // Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')
  registrationLink = new FormControl('', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]);

  minDate2: Date;
 // maxDate = new Date(this.todayDate.getFullYear(), this.todayDate.getMonth() + 4, this.todayDate.getDay());
  randomNumber: any;
  allBranches = new Array;
  currentBranch = new Array;
  ngOnInit() {
    console.log("token",localStorage.getItem("token"));
    // console.log('____________________________________',this.data)
    this.getAllShortName();
    this.branch.disable();
    //this.registrationLink.disable();
    //this.attendanceLink.disable();
    //this.accessCode.disable();
    this.randomNumber = Math.floor(Math.random() * 90000) + 100000;
    this.accessCode.setValue(this.randomNumber);
    this.getCompanies();
    this.getCollegeList('COLLEGE');
    this.getCollegeList('TRAINING_INSTITUTE');
    this.getDriveList();
    //this.allBranches = this.data.collegeDetail.branches;
    //console.log('________', this.allBranches);
    if (this.data !== null) {
      this.allBranches = this.data.collegeDetail.branches;
      console.log('________', this.allBranches);
      this.getBranch();
      this.branchId=this.currentBranch[0].id;
      this.branch = this.currentBranch[0];
      this.address.setValue(this.currentBranch[0].address);
      this.collegeName = this.data.collegeDetail.institutionName;
      this.institute = this.data.collegeDetail.institutionType;
      console.log('________', this.address);
    }
   // this.address.disabled;
  }
  getCompanies() {
    this.adminService.getCompanies()
      .subscribe(response => {
        this.companies = response as any;
        // console.log("Companies short name", this.companies);
      });
  }

  getBranch() {
    this.allBranches.filter(branch => branch.branchName === this.data.branchName).map(branch => this.currentBranch.push(branch));
  }

  onNoClick() {
    this.dialogRef.close();
  }

  // public noWhitespaceValidator(control: FormControl) {
  //   // console.log('value', control.value);

  //   const isWhitespace = (control.value || '').trim().length === 0;
  //   const isValid = !isWhitespace;
  //   return isValid ? null : { 'whitespace': true };
  // }

  public noWhitespaceValidator(control: FormControl) {
    console.log('value', control.value);

    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  getErrorMessageOfDriveName() {
    return this.driveName.hasError('required') ? 'Enter a Drive Name' :
      this.driveName.hasError('pattern') ? 'Enter Alphabet Value Only' :
        this.driveName.hasError('whitespace') ? 'Enter A Valid Input' :
          this.driveName.hasError('minlength') ? 'Minimum 3 Characters' : '';
  }

  getErrorMessageOfCity() {
    return this.city.hasError('required') ? 'Enter A City Name' :
      this.city.hasError('pattern') ? 'Enter Alphabet Value Only' :
        this.city.hasError('whitespace') ? 'Enter A Valid Input' :
        this.city.hasError('minlength') ? 'Minimum 3 Characters' : '';
  }

  getErrorMessageOfCompanyShortName() {
    return this.companyShortName.hasError('required') ? 'Select Company Short Name' : '';
  }
 
  getErrorMessageOfInstitutions() {
    return this.institute.hasError('required') ? 'Select Institution' : '';
  }

  getErrorMessageOfCollegeName() {
    return this.collegeName.hasError('required') ? 'Select a College Name' : '';
  }
  getErrorMessageOfInstituteName(){
    return this.collegeName.hasError('required') ? 'Select Institute Name' : ''; 
  }
  getErrorMessageOfbranch() {
    return this.branch.hasError('required') ? 'Select Branch' : '';
  }

  getErrorMessageOfAddress() {
    return this.address.hasError('required') ? 'Enter Address' :
    this.address.hasError('pattern') ? 'Invalid Address' :
      this.address.hasError('whitespace') ? 'Enter A Valid Input' : '';
  }

  getErrorMessageOfAccessCode() {
    return this.accessCode.hasError('required') ? 'Enter Access Code' :
      this.accessCode.hasError('pattern') ? 'Enter Integer Value Only' : '';
  }

  getErrorMessageOfRegistrationLink() {
    return this.registrationLink.hasError('required') ? 'Enter Registration Link' :
      this.registrationLink.hasError('pattern') ? 'Enter Correct URL' : '';
  }
  getErrorMessageOfAttendanceLink() {
    return this.attendanceLink.hasError('required') ? 'Enter Registration Link' :
      this.attendanceLink.hasError('pattern') ? 'Enter Correct URL' : '';
  }

  getErrorMessageOfShortName() {
    return this.shortName.hasError('required') ? 'Enter Short Name' :
      this.shortName.hasError('whitespace') ? 'Enter a Valid Input' : '';
  }
  getErrorMessageOfStartDate(){
    return this.startDate.hasError('required') ? 'Enter Start Date' : '';
  }
  getErrorMessageOfEndDate(){
    return this.endDate.hasError('required') ? 'Enter End Date' : '';
  }
  getErrorMessageOfEventDate(){
    return this.eventDate.hasError('required') ? 'Enter Event Date' : '';
  }
  getErrorMessageOfTime(){
    return this.time.hasError('required') ? 'Entre Time' : '';
  }


  getStartDate(): boolean {
    this.dateValid1();
    if (this.startDate.value !== '') {
     this.minDate1 = new Date(this.startDate.value.getFullYear(), this.startDate.value.getMonth(), this.startDate.value.getDate() + 1);
     this.end = false;
     return true;
     //this.dateValid1()
      // this.monthValue = this.startDate.value._i.month - this.todayDate.getMonth();
      // this.dateValue = this.startDate.value._i.date - this.todayDate.getDate() + 1;
      // this.minDate1 = new Date(this.todayDate.getFullYear(), this.todayDate.getMonth() + this.monthValue,
      //   this.todayDate.getDate() + this.dateValue + 1);
      // this.end = false;
      //return true;
    }
  }

  dateValid1() {
    console.log("startDate",this.startDate.value);
    console.log("minDate1",this.minDate1);
    if (this.startDate.value >= this.endDate.value) {
      //this.getStartDate();
      this.endDate.setValue('');
      this.eventDate.setValue('');
      this.time.setValue('');
      this.event = true;
      // this.dateValue = undefined;
      // this.monthValue = undefined;
      // this.minDate2 = undefined;
      // this.endDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      // this.eventDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      // this.end = true;
      // this.event = true;
    }
  }

  dateValid() {
    console.log("minDate1",this.minDate1);
    console.log("minDate2",this.minDate2);
    // if (this.minDate1 > this.minDate2) {
      if(this.endDate.value > this.eventDate.value) {
      //this.getStartDate();
      //this.endDate.setValue('');
      this.eventDate.setValue('');
      this.time.setValue('');
      this.time1 = true;
      // this.endDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      // this.eventDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      //this.end = true;
     // this.event = true;
      // this.dateValue = undefined;
      // this.monthValue = undefined;
      // this.minDate2 = undefined;
      // this.endDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      // this.eventDate = new FormControl({ value: '', disabled: true }, [Validators.required]);
      // this.end = true;
      // this.event = true;
    }
  }

  getEndDate(): boolean {
    this.dateValid();
    if (this.endDate.value !== '') {
      this.minDate2 = new Date(this.endDate.value.getFullYear(), this.endDate.value.getMonth(), this.endDate.value.getDate());
      this.event = false;
      return true;
      // this.dateValue = this.endDate.value._i.date - this.todayDate.getDate();
      // this.monthValue = this.endDate.value._i.month - this.todayDate.getMonth();
      // this.minDate2 = new Date(this.todayDate.getFullYear(), this.todayDate.getMonth() +this.monthValue 
      // , this.todayDate.getDate() + this.dateValue + 1);
      // this.event = false;
      // return true;
    }
  }

  getEventDate(): boolean {
    //this.dateValid();
    if (this.eventDate.value !== '') {
      this.time.setValue('');
      this.minTime = new Date(this.eventDate.value.getFullYear(), this.eventDate.value.getMonth(), this.eventDate.value.getDate(), 8, 0);
      this.maxTime = new Date(this.eventDate.value.getFullYear(), this.eventDate.value.getMonth(), this.eventDate.value.getDate(), 12, 0);
      this.time1 = false;
      this.startAt = new Date(this.eventDate.value.getFullYear(), this.eventDate.value.getMonth(), this.eventDate.value.getDate(), 8, 0);
      // this.dateValue = this.eventDate.value._i.date + 1;
      // this.monthValue = this.eventDate.value._i.month + 1;
      // this.yearValue = this.eventDate.value._i.year + 1;
      // this.minTime = new Date(this.yearValue, this.monthValue, this.dateValue, 8, 0);
      // this.maxTime = new Date(this.yearValue, this.monthValue, this.dateValue, 12, 0);
      // this.time1 = false;
      // this.startAt = new Date(this.yearValue, this.monthValue, this.dateValue, 8, 0);
    }
    return true;
  }

  copyUrl() {
    console.log("Registration Link", this.registrationLink.value);
    if (this.getErrorMessageOfRegistrationLink() === '') {
      if (this.registrationLink.value === '') {
        // this.snackBar.open('Enter Link', '', { duration: 2000 });
      } else {
        this.clipboardService.copyFromContent(this.registrationLink.value);
        this.snackBar.open('Copied to clipboard', '', { duration: 2000 });
      }
    }
  }

  copyAttendanceUrl() {
    if (this.getErrorMessageOfAttendanceLink() === '') {
      if (this.attendanceLink.value === '') {
        // this.snackBar.open('Enter Link', '', { duration: 2000 });
      } else {
        this.clipboardService.copyFromContent(this.attendanceLink.value);
        this.snackBar.open('Copied to clipboard', '', { duration: 2000 });
      }
    }
  }

  getAllShortName(){
    this.campaign.getAllShortName().subscribe(response => {
      console.log("Response", (response as any));
      this.shortNameList = (response as any).data;
    })
  }

  getCollegeList(campaignType: String): void {
    this.campaign.getListData(campaignType)
      .subscribe(response => {
        console.log("Response", (response as any).data);
        if((response as any).data != undefined || (response as any).data != null || (response as any).data != '') {
          //this.branchList = (response as any).data[0].institution.branches;
         // console.log("branchList",this.branchList);
          this.listData = (response as any).data;
          if (campaignType === 'COLLEGE') {
            this.collegeList = (response as any).data;
            console.log("CollegeList",this.collegeList);
          }
          this.typeList = this.collegeList;
          if (campaignType === 'TRAINING_INSTITUTE') {
            this.instituteList = (response as any).data;
            console.log("Traning institute List",this.instituteList);
          }
        }
       
      });
  }

  getDriveList(): void {
    this.drive.getDriveListData().subscribe(response => {
      // console.log('Response', response);
      this.dataList = (response as any).data;
      // console.log('DataList', this.dataList);
    });
  }

  changeUrlByShortName(event) {
    if(this.shortName.value != '')
      this.visible = true;
    else
      this.visible = false;
    //console.log("Short Name:", this.shortName.value);
    let tempUrl = this.shortName.value + "";
    // console.log("tempUrl", tempUrl);
    tempUrl = tempUrl.trim().replace(/ +/g, '-').replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
      .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');

    //this.shortName.setValue(tempUrl);
    this.temp = tempUrl;

    this.registrationLink.setValue(environment.campaignUrl1 + tempUrl);
    this.attendanceLink.setValue(environment.attendanceUrl + tempUrl);



    // console.log('short name-->' + this.shortName.value);

    // let tempUrl = this.shortName.value + "";
    // console.log('temp -->', tempUrl);

    // tempUrl = tempUrl.trim().replace(/ +/g, '-').replace(new RegExp(/([/.\\#?%&(){},:;])/g), "-")
    //   .replace(new RegExp(/([-]{2,})/g), "-").replace(new RegExp(/ /g), '');
    // let i = 0;
    // if (this.instituteType == "COLLEGE") {
    //   this.collegeList.map(campaignObject => {
    //     if (campaignObject.shortName === tempUrl) {
    //       i++;
    //       // console.log(i);

    //     }
    //   });
    // }
    // console.log('before substring tempUrl', tempUrl);

    // if (i != 0)
    //   tempUrl = tempUrl.substr(0, tempUrl.length - 1) + (Number(tempUrl.substr(tempUrl.length - 1)) + i);
    // //this.shortName.setValue(tempUrl);
    // console.log(tempUrl);
    // this.url.setValue(environment.campaignUrl + tempUrl);
  }

  changeShortName() {
    this.shortNameStatus = false;
    for (let i = 0; i < this.shortNameList.length; i++) {
      if (this.shortName.value === this.shortNameList[i]) {
        this.shortNameStatus = true;
        // console.log('input-->', this.shortName.value);
        // console.log('comparte with -->', this.dataList[i].shortName);
        // console.log('shortNameStatus-->', this.shortNameStatus);
      }
    }
  }

  check() {
    // console.log("Institute", this.institute.value);
    this.branch.setValue('');
    if (this.institute.value === 'Others' || this.institute.value === 'BridgeLabz') {
      this.isOthers = true;
      this.address.disable();
    }
  }

  college() {
    // console.log('CollegeName', this.collegeName.value);
    if (this.institute.value !== '') {
      this.branchArr = this.collegeName.value.institution.branches;
      console.log("Branch Array",this.branchArr);
      this.address.setValue('');
      this.branch.enable();
    } else {
      this.branch.disable();
    }
  }

  branch1(event) {
    console.log("BranchList",this.branchArr);
   // this.branchList.filter(branch2 => branch2.branchName === event.value);
    for(var i = 0; i < this.branchArr.length; i++)
    {
      console.log("this.branchArr[i].branchName",this.branchArr[i].branchName);
      console.log("event.value.branchName",event.value.branchName);
      
      
      if(this.branchArr[i].branchName === event.value.branchName){
        this.address.setValue(this.branchArr[i].address);
        //this.address = this.branchList[i].address;
      }
    }
    console.log("Address --->",this.address.value);
    //console.log("Branch2",branch2)
    console.log("Branch:", this.branch.value.branchName);
    console.log("Branch event",event.value.branchName);

  }

  submit() {
    console.log('date is ',moment(this.eventDate.value).format('YYYY-MM-DDTHH:mm:ss'));

    // console.log("Temp",this.temp);
    // console.log("Data",this.data);
    this.shortName.setValue(this.temp);
    // console.log("Shortname",this.shortName.value);
    // console.log("Institute",this.institute);
    // console.log("CollegeName",this.collegeName);
    // console.log("Branch",this.collegeName);
    // console.log("Address",this.address);
    //this.changeUrlByShortName();
    
     // console.log("Institute",this.institute);
    //console.log("CollegeName",this.data.collegeDetail.id);
    //console.log("Branch",this.branchId);
   // console.log("Address",this.address.value);
    try {
      if (this.shortNameStatus === true) throw "ShortName is already present"
      // console.log("Start date", this.startDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"));
     
      if(this.data === null){
      this.requestBody = {
        
        address: this.address.value,
        attendanceAccessCode: this.accessCode.value,
        city: this.city.value,
        companyShortName: this.companyShortName.value,
        driveName: this.driveName.value,
        eventDate:moment(this.eventDate.value).format('YYYY-MM-DDTHH:mm:ss'),
        eventEndDate: moment(this.endDate.value).format("YYYY-MM-DDTHH:mm:ss"),
        eventStartDate: moment(this.startDate.value).format("YYYY-MM-DDTHH:mm:ss"),
        // eventDate: this.eventDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
        // eventEndDate: this.endDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
        // eventStartDate: this.startDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
        eventTime: this.time.value.toLocaleTimeString(),
        shortName: this.shortName.value,
        registrationAccessCode: this.registrationLink.value,
      
          institutionBranchId: this.branch.value.id,
          institutionId: this.collegeName.value.institution.id,
          instituteType: this.collegeName.value.institution.institutionType,
      }
    }
    else{
      console.log('date is ',moment(this.eventDate.value).format('YYYY-MM-DDTHH:mm:ss'));
      
        this.requestBody = {
          
          address: this.address.value,
          attendanceAccessCode: this.accessCode.value,
          city: this.city.value,
          companyShortName: this.companyShortName.value,
          driveName: this.driveName.value,
          eventDate:moment(this.eventDate.value).format('YYYY-MM-DDTHH:mm:ss'),
          eventEndDate: moment(this.endDate.value).format("YYYY-MM-DDTHH:mm:ss"),
          eventStartDate: moment(this.startDate.value).format("YYYY-MM-DDTHH:mm:ss"),
          //eventDate: this.eventDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
          //eventEndDate: this.endDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
          // eventStartDate: this.startDate.value.utc().format("YYYY-MM-DDTHH:mm:ss"),
          eventTime: this.time.value.toLocaleTimeString(),
          shortName: this.shortName.value,
          registrationAccessCode: this.registrationLink.value,
        
            institutionBranchId: this.branchId,
            institutionId: this.data.collegeDetail.id,
            instituteType:this.institute,
          
        }
     }
     
       console.log("563--------------------:", this.requestBody);
       this.utilityService.showSpinner();
      this.drive.addDrive(this.requestBody).subscribe(response => {
        this.utilityService.hideSpinner();
        console.log("Response", response);
        this.drive.update('Added');
        console.log("Drive response",response['data']['message']);
        if(this.data === null)
          this.utilityService.openSnackBar(response['data']['message']);
        else
          this.utilityService.openSnackBar("Event Added Successfully.");
        if(this.shortName.value === "")
          this.disableButton = true;
        this.dialogRef.close("Added");
      },
        err => {
          this.utilityService.hideSpinner();
          console.log("Error ",err);
          this.utilityService.openSnackBar(err.error.detail);
          

        })
    } catch (error) {
      this.utilityService.hideSpinner();
      console.log('error--->',error);
      this.snackBar.open(error, "", { duration: 3000 });
    }
  }

}